import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)


// 重复点击路由错误
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home
    },
    {
        path: '/Home',
        name: 'Home',
        component: function () {
            return import(/* webpackChunkName: "about" */ '../views/Home.vue')
        }
    },
    {
        path: '/AfterSalesService',
        name: 'AfterSalesService',
        component: function () {
            return import(/* webpackChunkName: "about" */ '../views/AfterSalesService.vue')
        }
    },
    {
        path: '/CompanyProfile',
        name: 'CompanyProfile',
        component: function () {
            return import(/* webpackChunkName: "about" */ '../views/CompanyProfile.vue')
        }
    },
    {
        path: '/ProjectCase',
        name: 'ProjectCase',
        component: function () {
            return import(/* webpackChunkName: "about" */ '../views/ProjectCase.vue')
        }
    },
    {
        path: '/ProjectDescription',
        name: 'ProjectDescription',
        component: function () {
            return import(/* webpackChunkName: "about" */ '../views/ProjectDescription.vue')
        }
    },
    {
        path: '/Test',
        name: 'Test',
        component: function () {
            return import(/* webpackChunkName: "about" */ '../test/Test.vue')
        }
    },
    {
        path: '/Detail',
        name: 'Detail',
        component: function () {
            return import(/* webpackChunkName: "about" */ '../views/Detail.vue')
        }
    }
]

const router = new VueRouter({
    mode: "hash",
    routes
})

// 跳转后返回顶部
router.afterEach((to, from, next) => {
    window.scrollTo(0, 0);
})

export default router
